import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {
  getButtonVariable,
  SERVER_BUTTON,
  transformClientFormatToServer as transformClientFormatToServerV3,
} from '../lib/buttonModelV3';
import { destroy } from 'redux-form';
import { BTN_FACTORY_V3_FORM } from '../clientConstants';
import { fetcher } from '../../utility/domUtils';

export const BUTTON_FACTORY_BUSY = 'BUTTON_FACTORY_BUSY';
export const INITIALIZE_WIZARD = 'INITIALIZE_WIZARD';
export const WIZARD_CONTINUE = 'WIZARD_CONTINUE';
export const WIZARD_BACK = 'WIZARD_BACK';
export const WIZARD_SET_CURRENT_PAGE = 'WIZARD_SET_CURRENT_PAGE';
export const GET_BUTTON_DATA_SUCCESS = 'GET_BUTTON_DATA_SUCCESS';
export const GET_BUTTON_DATA_ERROR = 'GET_BUTTON_DATA_ERROR';
export const CREATE_BUTTON_SUCCESS = 'CREATE_BUTTON_SUCCESS';
export const CREATE_BUTTON_ERROR = 'CREATE_BUTTON_ERROR';
export const EDIT_BUTTON_SUCCESS = 'EDIT_BUTTON_SUCCESS';
export const EDIT_BUTTON_ERROR = 'EDIT_BUTTON_ERROR';
export const UPDATE_CODE_SNIPPET = 'UPDATE_CODE_SNIPPET';
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
export const SHOW_ACTIONABLE_ERROR_MODAL = 'SHOW_ACTIONABLE_ERROR_MODAL';
export const HIDE_ACTIONABLE_ERROR_MODAL = 'HIDE_ACTIONABLE_ERROR_MODAL';
export const SHOW_UNACTIONABLE_ERROR_MODAL = 'SHOW_UNACTIONABLE_ERROR_MODAL';
export const HIDE_UNACTIONABLE_ERROR_MODAL = 'HIDE_UNACTIONABLE_ERROR_MODAL';
export const SHOW_LEAVE_MODAL = 'SHOW_LEAVE_MODAL';
export const HIDE_LEAVE_MODAL = 'HIDE_LEAVE_MODAL';
export const SET_ERROR_LOADING_IMAGE = 'SET_ERROR_LOADING_IMAGE';
export const RESET_ERROR_LOADING_IMAGE = 'RESET_ERROR_LOADING_IMAGE';
export const OPEN_MOBILE_PREVIEW = 'OPEN_MOBILE_PREVIEW';
export const CLOSE_MOBILE_PREVIEW = 'CLOSE_MOBILE_PREVIEW';
export const UPDATE_IS_MOBILE = 'UPDATE_IS_MOBILE';
export const UPDATE_FLOW_SPEC = 'UPDATE_FLOW_SPEC';
export const UPDATE_BUSINESS_IMAGE_URLS = 'UPDATE_BUSINESS_IMAGE_URLS';

const transformClientFormatToServer = transformClientFormatToServerV3;

export function goToNextStep() {
  return {
    type: WIZARD_CONTINUE,
  };
}

export function goToPreviousStep() {
  return {
    type: WIZARD_BACK,
  };
}

export function setCurrentStep(stepNumber) {
  return {
    type: WIZARD_SET_CURRENT_PAGE,
    payload: stepNumber,
  };
}

export function initializeWizard(button) {
  return {
    type: INITIALIZE_WIZARD,
    payload: button,
  };
}

export function busy() {
  return {
    type: BUTTON_FACTORY_BUSY,
  };
}

export function getButton(buttonId) {
  return (dispatch, getState) => {
    dispatch(busy());

    return fetcher(`/donate/api/buttons/${buttonId}`)
      .then((response) => response.json())
      .then((response) => {
        const button = _get(response, 'button');

        // When V3 is enabled, and a merchant is editing an V2
        // button, int_type should be default to 'C'
        const flowType = getButtonVariable(button, 'int_type');
        if (_isEmpty(flowType)) {
          button.button_variables.push({
            name: SERVER_BUTTON.FLOW_TYPE,
            value: 'C',
          });
        }

        dispatch({
          type: GET_BUTTON_DATA_SUCCESS,
          payload: button,
        });

        return button;
      })
      .catch((err) => {
        const error = _get(err, 'responseJSON.button');
        dispatch({
          type: GET_BUTTON_DATA_ERROR,
          payload: { error },
        });
        return err;
      });
  };
}

export function saveButton(buttonData) {
  return (dispatch) => {
    if (buttonData.id) {
      return dispatch(updateButton(buttonData));
    }

    return dispatch(createButton(buttonData));
  };
}

export function createButton(buttonData) {
  const buttonDataServerFormat = transformClientFormatToServer(buttonData);

  return (dispatch, getState) => {
    dispatch(busy());

    let resParams = {};
    return fetcher('/donate/api/buttons', {
      method: 'POST',
      body: JSON.stringify({
        button: buttonDataServerFormat,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: CREATE_BUTTON_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const button = _get(responseJson, 'button');
        button.merchantExperienceUrls = _get(
          responseJson,
          'data.clientData.merchantExperienceUrls'
        );
        dispatch({
          type: CREATE_BUTTON_SUCCESS,
          payload: button,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: CREATE_BUTTON_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}

export function updateButton(buttonData) {
  const buttonDataServerFormat = transformClientFormatToServer(buttonData);

  return (dispatch, getState) => {
    dispatch(busy());

    let resParams = {};
    return fetcher(`/donate/api/buttons/${buttonData.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        button: buttonDataServerFormat,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: EDIT_BUTTON_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const button = _get(responseJson, 'button');
        dispatch({
          type: EDIT_BUTTON_SUCCESS,
          payload: button,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: EDIT_BUTTON_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}

export function updateCodeSnippet(code) {
  return {
    type: UPDATE_CODE_SNIPPET,
    payload: code,
  };
}

export function showLoginModal() {
  return {
    type: SHOW_LOGIN_MODAL,
  };
}

export function hideLoginModal() {
  return {
    type: HIDE_LOGIN_MODAL,
  };
}

export function showActionableErrorModal() {
  return {
    type: SHOW_ACTIONABLE_ERROR_MODAL,
  };
}

export function hideActionableErroModal() {
  return {
    type: HIDE_ACTIONABLE_ERROR_MODAL,
  };
}

export function showUnactionableErrorModal() {
  return {
    type: SHOW_UNACTIONABLE_ERROR_MODAL,
  };
}

export function hideUnactionableErrorModal() {
  return {
    type: HIDE_UNACTIONABLE_ERROR_MODAL,
  };
}

export function showLeaveModal() {
  return {
    type: SHOW_LEAVE_MODAL,
  };
}

export function hideLeaveModal() {
  return {
    type: HIDE_LEAVE_MODAL,
  };
}

export function destroyForm() {
  return (dispatch) => {
    const form = BTN_FACTORY_V3_FORM;
    dispatch(destroy(form));
  };
}

export function setErrorLoadingLogoImage() {
  return {
    type: SET_ERROR_LOADING_IMAGE,
  };
}

export function resetErrorLoadingLogoImage() {
  return {
    type: RESET_ERROR_LOADING_IMAGE,
  };
}

export function openMobilePreview() {
  return {
    type: OPEN_MOBILE_PREVIEW,
  };
}

export function closeMobilePreview() {
  return {
    type: CLOSE_MOBILE_PREVIEW,
  };
}

export function updateIsMobile(isMobile) {
  return {
    type: UPDATE_IS_MOBILE,
    payload: isMobile,
  };
}

export function updateFlowSpec(flowSpec) {
  return {
    type: UPDATE_FLOW_SPEC,
    payload: flowSpec,
  };
}

export function uploadImage(imageUrl) {
  return () => {
    let resParams = {};
    return fetcher('/donate/api/imageUpload', {
      method: 'POST',
      body: JSON.stringify({
        src: imageUrl,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJson: responseJson.success,
            ...resParams,
          };
          return error;
        }
        const url = _get(responseJson, 'url');
        return { src: url.imageUrl, ok: resParams.ok, success: url.success };
      })
      .catch((error) => {
        return error;
      });
  };
}

export function updateBusinessProfileLogo(imageUrl) {
  return () => {
    let resParams = {};
    return fetcher('/donate/api/updateBusinessProfile', {
      method: 'PUT',
      body: JSON.stringify({
        url: imageUrl,
      }),
    })
      .then((response) => {
        resParams = {
          resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            success: responseJson.success,
            ...resParams,
          };
          return error;
        }
        return { ok: resParams.ok, success: responseJson.success };
      })
      .catch((error) => {
        return error;
      });
  };
}

export function updateBusinessImageUrls(url) {
  return {
    type: UPDATE_BUSINESS_IMAGE_URLS,
    url,
  };
}
